import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import {
  updateTitle,
  updateCategory,
  updateSlug,
  updateTagline,
  updateYtVideoLink1,
  updateYtVideoLink2,
  updateYtVideoLink3,
  updateFeatureImage,
  updateTechnologies,
  updatePlatform,
  updateIndustry,
  updateCountry,
  updateFirstDesc,
  updateDescImage1,
  updateDescImage2,
  updateDescImage3,
  updateDescImage4,
  updateHighlightImage,
  updateMetaTitle,
  updateMetaDescription,
} from "../redux/portfolio/actions";

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

function CreatePortfolioPost() {
  const dispatch = useDispatch();
  const {
    slug,
    category,
    title,
    tagline,
    featureImage,
    technologies,
    platform,
    industry,
    country,
    firstDescription,
    youtube1,
    youtube2,
    youtube3,
    descImage1,
    descImage2,
    descImage3,
    descImage4,
    highlightImage,
    metaTitle,
    metaDescription,
  } = useSelector((state) => state.portfolio);

  // State for multiple feature images
  const [featureImages, setFeatureImages] = useState([]);
  const [featureImgError, setFeatureImgError] = useState("");
  const [featureimageUploadState, setFeatureImageUploadState] = useState("");
  const [highlightImgError, setHighlightImgError] = useState("");
  const [highlightImgState, setHighlightImgState] = useState("");
  // Other states
  const [formerror, setFormError] = useState({});
  const [descImage1Err, setdescImage1Err] = useState("");
  const [descImage1State, setdescImage1State] = useState("");
  const [descImage2Err, setdescImage2Err] = useState("");
  const [descImage2State, setdescImage2State] = useState("");
  const [descImage3Err, setdescImage3Err] = useState("");
  const [descImage3State, setdescImage3State] = useState("");
  const [descImage4Err, setdescImage4Err] = useState("");
  const [descImage4State, setdescImage4State] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [publishError, setPublishError] = useState(null);
  const [successMsg, setSuccessMsg] = useState(false);
  console.log("Creating Portfolio Post...", featureImages);
  const handleInputChange = (e) => setInputValue(e.target.value);
  const [selectedTechId, setSelectedTechId] = useState("");
  const [availableTechnologies, setAvailableTechnologies] = useState([]);
  const [enteredtechnologies, setEnteredTechnologies] = useState([]);

  useEffect(() => {
    const fetchTechnologies = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/technologie`, {
          method: "GET",
        });
        const data = await res.json();
        if (data.statusCode === 200) {
          setAvailableTechnologies(data.data);
        } else {
          console.error("Failed to fetch technologies:", data.message);
        }
      } catch (error) {
        console.error("Error fetching technologies:", error.message);
      }
    };
    fetchTechnologies();
  }, []);

  const handleAddTechnology = () => {
    if (selectedTechId) {
      const selectedTech = availableTechnologies.find(
        (tech) => tech._id === selectedTechId
      );
      if (selectedTech) {
        const newTech = {
          index: enteredtechnologies.length + 1,
          name: selectedTech.name,
          image: selectedTech.image,
        };
        setEnteredTechnologies([...enteredtechnologies, newTech]);
        setSelectedTechId(""); // Reset dropdown
      }
    }
  };

  const handleDeleteTechnology = (index) => {
    const updatedTechList = enteredtechnologies
      .filter((_, i) => i !== index)
      .map((tech, i) => ({ ...tech, index: i + 1 })); // Reassign indices
    setEnteredTechnologies(updatedTechList);
  };

  const handleFeatureImgChange = async (event) => {
    setFeatureImageUploadState("Uploading Images...");
    const files = Array.from(event.target.files);
    const uploadPromises = files.map(async (selectedFile) => {
      if (!selectedFile.type.startsWith("image/")) {
        setFeatureImgError("Please Upload Image Files Only.");
        setFeatureImageUploadState("");
        return null;
      }
      try {
        const res = await fetch(`${BASE_URL}/api/blog/getuploadurl`, {
          method: "GET",
        });
        const data = await res.json();
        if (data.url) {
          const uploadRes = await fetch(data.url, {
            method: "PUT",
            body: selectedFile,
          });
          if (uploadRes.ok) {
            const indexOfQuestionMark = data.url.indexOf("?");
            return data.url.substring(0, indexOfQuestionMark);
          }
        }
      } catch (error) {
        setFeatureImgError(error.message);
        setFeatureImageUploadState("");
        return null;
      }
    });

    try {
      const uploadedUrls = (await Promise.all(uploadPromises)).filter(
        (url) => url
      );
      if (uploadedUrls.length > 0) {
        const newFeatureImages = [...featureImages, ...uploadedUrls];
        setFeatureImages(newFeatureImages);
        dispatch(updateFeatureImage(newFeatureImages));
        setFeatureImageUploadState("Images Uploaded!");
      } else {
        setFeatureImageUploadState("");
      }
    } catch (error) {
      setFeatureImgError(error.message);
      setFeatureImageUploadState("");
    }
  };

  const handleRemoveFeatureImage = (index) => {
    const updatedImages = featureImages.filter((_, i) => i !== index);
    setFeatureImages(updatedImages);
    dispatch(updateFeatureImage(updatedImages));
  };

  const handleHighlightImgChange = async (event) => {
    setHighlightImgState("Uploading Image...");
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (!selectedFile.type.startsWith("image/")) {
        setHighlightImgError("Please Upload Image File.");
        setHighlightImgState("");
        event.target.value = "";
        return;
      }
      try {
        const res = await fetch(`${BASE_URL}/api/blog/getuploadurl`, {
          method: "GET",
        });
        const data = await res.json();
        if (data.url) {
          const uploadRes = await fetch(data.url, {
            method: "PUT",
            body: selectedFile,
          });
          if (uploadRes.ok) {
            const indexOfQuestionMark = data.url.indexOf("?");
            const originalUrl = data.url.substring(0, indexOfQuestionMark);
            setHighlightImgState("Image Uploaded!");
            dispatch(updateHighlightImage(originalUrl));
          }
        }
      } catch (error) {
        setHighlightImgError(error.message);
        setHighlightImgState("");
      }
    }
  };

  const handleRemoveHighlightImage = () => {
    dispatch(updateHighlightImage(""));
    setHighlightImgState("");
  };

  const handledescImage1 = async (event) => {
    setdescImage1State("Uploading Image...");
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (!selectedFile.type.startsWith("image/")) {
        setdescImage1Err("Please Upload Image File.");
        setdescImage1State("");
        event.target.value = "";
        return;
      }
      try {
        const res = await fetch(`${BASE_URL}/api/blog/getuploadurl`, {
          method: "GET",
        });
        const data = await res.json();
        if (data.url) {
          const uploadRes = await fetch(data.url, {
            method: "PUT",
            body: selectedFile,
          });
          if (uploadRes.ok) {
            const indexOfQuestionMark = data.url.indexOf("?");
            const originalUrl = data.url.substring(0, indexOfQuestionMark);
            setdescImage1State("Image Uploaded!");
            dispatch(updateDescImage1(originalUrl));
          }
        }
      } catch (error) {
        setdescImage1Err(error.message);
        setdescImage1State("");
      }
    }
  };

  const handleRemoveDescImage1 = () => {
    dispatch(updateDescImage1(""));
    setdescImage1State("");
  };

  const handledescImage2 = async (event) => {
    setdescImage2State("Uploading Image...");
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (!selectedFile.type.startsWith("image/")) {
        setdescImage2Err("Please Upload Image File.");
        setdescImage2State("");
        event.target.value = "";
        return;
      }
      try {
        const res = await fetch(`${BASE_URL}/api/blog/getuploadurl`, {
          method: "GET",
        });
        const data = await res.json();
        if (data.url) {
          const uploadRes = await fetch(data.url, {
            method: "PUT",
            body: selectedFile,
          });
          if (uploadRes.ok) {
            const indexOfQuestionMark = data.url.indexOf("?");
            const originalUrl = data.url.substring(0, indexOfQuestionMark);
            setdescImage2State("Image Uploaded!");
            dispatch(updateDescImage2(originalUrl));
          }
        }
      } catch (error) {
        setdescImage2Err(error.message);
        setdescImage2State("");
      }
    }
  };

  const handleRemoveDescImage2 = () => {
    dispatch(updateDescImage2(""));
    setdescImage2State("");
  };

  const handledescImage3 = async (event) => {
    setdescImage3State("Uploading Image...");
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (!selectedFile.type.startsWith("image/")) {
        setdescImage3Err("Please Upload Image File.");
        setdescImage3State("");
        event.target.value = "";
        return;
      }
      try {
        const res = await fetch(`${BASE_URL}/api/blog/getuploadurl`, {
          method: "GET",
        });
        const data = await res.json();
        if (data.url) {
          const uploadRes = await fetch(data.url, {
            method: "PUT",
            body: selectedFile,
          });
          if (uploadRes.ok) {
            const indexOfQuestionMark = data.url.indexOf("?");
            const originalUrl = data.url.substring(0, indexOfQuestionMark);
            setdescImage3State("Image Uploaded!");
            dispatch(updateDescImage3(originalUrl));
          }
        }
      } catch (error) {
        setdescImage3Err(error.message);
        setdescImage3State("");
      }
    }
  };

  const handleRemoveDescImage3 = () => {
    dispatch(updateDescImage3(""));
    setdescImage3State("");
  };

  const handledescImage4 = async (event) => {
    setdescImage4State("Uploading Image...");
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (!selectedFile.type.startsWith("image/")) {
        setdescImage4Err("Please Upload Image File.");
        setdescImage4State("");
        event.target.value = "";
        return;
      }
      try {
        const res = await fetch(`${BASE_URL}/api/blog/getuploadurl`, {
          method: "GET",
        });
        const data = await res.json();
        if (data.url) {
          const uploadRes = await fetch(data.url, {
            method: "PUT",
            body: selectedFile,
          });
          if (uploadRes.ok) {
            const indexOfQuestionMark = data.url.indexOf("?");
            const originalUrl = data.url.substring(0, indexOfQuestionMark);
            setdescImage4State("Image Uploaded!");
            dispatch(updateDescImage4(originalUrl));
          }
        }
      } catch (error) {
        setdescImage4Err(error.message);
        setdescImage4State("");
      }
    }
  };

  const handleRemoveDescImage4 = () => {
    console.log("Removing desc image 4");
    dispatch(updateDescImage4(""));
    setdescImage4State("");
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "text-align", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "image",
  ];

  const validation = () => {
    let err = {};
    if (title === "") err.portfolio_title = "Please Enter Title.";
    if (featureImages.length === 0)
      err.featureImage = "Please Upload at least one Feature Image.";
    if (slug === "") err.slug = "Please Enter Slug.";
    if (tagline === "") err.tagline = "Please Enter tagline content.";
    if (enteredtechnologies.length === 0)
      err.technologies = "Please Enter at least one Technology.";
    if (platform === "") err.platform = "Please Enter platform content.";
    if (industry === "") err.industry = "Please Enter industry content.";
    if (country === "") err.country = "Please Enter country content.";
    if (firstDescription === "")
      err.firstDescription = "Please Enter firstDescription content.";
    if (highlightImage === "")
      err.highlightImage = "Please Upload Highlight Image.";
    if (!metaTitle.trim()) err.metaTitle = "Please enter a Meta Title.";
    if (!metaDescription.trim())
      err.metaDescription = "Please enter a Meta Description.";

    if (
      !category ||
      (Array.isArray(category) && category.length === 0) ||
      (!Array.isArray(category) && category === "")
    ) {
      err.category = "Please select at least one category.";
    }
    setFormError({ ...err });
    return Object.keys(err).length < 1;
  };

  const handleSubmit = async () => {
    let isvalid = validation();
    if (isvalid) {
      try {
        const res = await fetch(`${BASE_URL}/api/portfolio/create`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: title,
            slug: slug,
            featureImage: featureImages,
            category: category,
            taglineDesc: tagline,
            technologies: enteredtechnologies,
            platform: platform,
            industry: industry,
            country: country,
            firstdescription: firstDescription,
            youtube1: youtube1,
            youtube2: youtube2,
            youtube3: youtube3,
            projectImg1: descImage1,
            projectImg2: descImage2,
            projectImg3: descImage3,
            projectImg4: descImage4,
            highlightImage: highlightImage,
            metaTitle: metaTitle,
            metaDescription: metaDescription,
          }),
        });
        const data = await res.json();
        console.log(data);
        if (!res.ok) {
          setPublishError(data.message);
          return;
        }
        if (res.ok) {
          setPublishError(null);
          setSuccessMsg(true);
        }
      } catch (error) {
        setPublishError(error.message);
      }
    }
  };

  return (
    <div className="container">
      <h3
        className="fw-bold mb-4"
        style={{
          color: "#1e3a8a",
          letterSpacing: "-0.5px",
        }}
      >
        Create Portfolio Post
      </h3>
      <form>
        {/* Portfolio Title & Meta Title side by side */}
        <div className="row mb-4">
          <div className="col-md-6">
            <label className="fw-semibold mb-2 d-block">Portfolio Title</label>
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Portfolio Title"
              name="portfolio_title"
              onChange={(e) => dispatch(updateTitle(e.target.value))}
              value={title}
              style={{
                borderRadius: "6px",
                borderColor: "#d0d5dd",
                padding: "0.65rem 0.85rem",
              }}
            />
            <div className="text-danger small">{formerror.portfolio_title}</div>
          </div>
          <div className="col-md-6">
            <label className="fw-semibold mb-2 d-block">Meta Title</label>
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Enter Meta Title"
              onChange={(e) => dispatch(updateMetaTitle(e.target.value))}
              value={metaTitle}
              style={{
                borderRadius: "6px",
                borderColor: "#d0d5dd",
                padding: "0.65rem 0.85rem",
              }}
            />
            <div className="text-danger small">{formerror.metaTitle}</div>
          </div>
        </div>

        {/* Tagline */}
        <div className="mb-4">
          <label className="fw-semibold mb-2 d-block">Tagline / Short Description</label>
          <textarea
            className="form-control shadow-sm"
            placeholder="Enter a short tagline or description for this project"
            rows={2}
            onChange={(e) => dispatch(updateTagline(e.target.value))}
            value={tagline}
            style={{
              borderRadius: "6px",
              borderColor: "#d0d5dd",
              padding: "0.65rem 0.85rem",
              resize: "vertical",
            }}
          />
          <div className="text-danger small">{formerror.tagline}</div>
        </div>

        {/* Meta Description */}
        <div className="mb-4">
          <label className="fw-semibold mb-2 d-block">Meta Description</label>
          <textarea
            className="form-control shadow-sm"
            placeholder="Enter Meta Description (for SEO)"
            rows={3}
            onChange={(e) => dispatch(updateMetaDescription(e.target.value))}
            value={metaDescription}
            style={{
              borderRadius: "6px",
              borderColor: "#d0d5dd",
              padding: "0.65rem 0.85rem",
              resize: "vertical",
            }}
          />
          <div className="text-danger small">{formerror.metaDescription}</div>
        </div>

        {/* Highlight Image & Feature Images side by side */}
        <div className="row mb-4">
          <div className="col-md-6">
            <label className="fw-semibold mb-2 d-block">Upload Highlight Image</label>
            <input
              type="file"
              className="form-control shadow-sm"
              onChange={handleHighlightImgChange}
              style={{
                borderRadius: "6px",
                padding: "0.65rem 0.85rem",
                borderColor: "#d0d5dd",
              }}
            />
            <div className="text-danger small">
              {formerror.highlightImage}
              {highlightImgError ? <br /> : null}
              {highlightImgError}
            </div>
            {highlightImage ? (
              <div className="mt-2">
                <img
                  src={highlightImage}
                  alt="Highlight"
                  className="img-thumbnail"
                  style={{ maxWidth: "300px", borderRadius: "10px" }}
                />
                <button
                  type="button"
                  className="btn btn-outline-danger btn-sm mt-2"
                  style={{ borderRadius: "4px" }}
                  onClick={handleRemoveHighlightImage}
                >
                  Remove
                </button>
              </div>
            ) : (
              <div className="text-muted">{highlightImgState}</div>
            )}
          </div>
          <div className="col-md-6">
            <label className="fw-semibold mb-2 d-block">Upload Feature Images</label>
            <input
              type="file"
              className="form-control shadow-sm"
              multiple
              onChange={handleFeatureImgChange}
              style={{
                borderRadius: "6px",
                padding: "0.65rem 0.85rem",
                borderColor: "#d0d5dd",
              }}
            />
            <div className="text-danger small">
              {formerror.featureImage}
              {featureImgError ? <br /> : null}
              {featureImgError}
            </div>
            {featureImages.length > 0 ? (
              <div className="mt-2 d-flex flex-wrap gap-2">
                {featureImages.map((img, index) => (
                  <div key={index} className="text-center">
                    <img
                      src={img}
                      alt={`Uploaded ${index}`}
                      className="img-thumbnail"
                      style={{ maxWidth: "120px", borderRadius: "10px" }}
                    />
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm mt-1"
                      style={{ borderRadius: "4px" }}
                      onClick={() => handleRemoveFeatureImage(index)}
                    >
                      Remove
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-muted">{featureimageUploadState}</div>
            )}
          </div>
        </div>
        <div className="mb-4">
          <label className="fw-semibold mb-2 d-block">Category</label>
          <div className="d-flex flex-wrap gap-3">
            {[
              { value: "web", label: "Web" },
              { value: "mobile", label: "Mobile" },
              { value: "ai-ml", label: "AI/ML" },
              { value: "iot", label: "IOT" },
              { value: "ar", label: "Augmented Reality" },
              { value: "unity", label: "Unity 3D" },
            ].map((option) => (
              <div key={option.value} className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={option.value}
                  value={option.value}
                  checked={
                    Array.isArray(category)
                      ? category.includes(option.value)
                      : category === option.value
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    const isChecked = e.target.checked;
                    const currentCategories = Array.isArray(category)
                      ? category
                      : category
                      ? [category]
                      : [];
                    let updatedCategories;
                    if (isChecked) {
                      updatedCategories = currentCategories.includes(value)
                        ? currentCategories
                        : [...currentCategories, value];
                    } else {
                      updatedCategories = currentCategories.filter(
                        (cat) => cat !== value
                      );
                    }
                    dispatch(updateCategory(updatedCategories));
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor={option.value}
                >
                  {option.label}
                </label>
              </div>
            ))}
          </div>
          <div className="text-danger small">{formerror.category}</div>
        </div>
        {/* Portfolio Details Grid */}
        <div className="row mb-4">
          {/* Slug */}
          <div className="col-md-6 mb-3">
            <label className="fw-semibold mb-2 d-block">Enter Slug</label>
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Enter the Slug"
              name="slug"
              onChange={(e) => dispatch(updateSlug(e.target.value))}
              value={slug}
              style={{
                borderRadius: "6px",
                borderColor: "#d0d5dd",
                padding: "0.65rem 0.85rem",
              }}
            />
            <div className="text-danger small">{formerror.slug}</div>
          </div>
          {/* Technologies */}
          <div className="col-md-6 mb-3">
            <label className="fw-semibold mb-2 d-block">Select Technologies</label>
            <select
              className="form-select shadow-sm"
              value={selectedTechId}
              onChange={(e) => setSelectedTechId(e.target.value)}
              style={{
                borderRadius: "6px",
                borderColor: "#d0d5dd",
                padding: "0.65rem 0.85rem",
              }}
            >
              <option value="">Select a Technology</option>
              {availableTechnologies.map((tech) => (
                <option key={tech._id} value={tech._id}>
                  {tech.name}
                </option>
              ))}
            </select>
            <div className="d-flex gap-2 mt-2">
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                style={{ borderRadius: "6px", padding: "0.55rem 1.1rem" }}
                onClick={handleAddTechnology}
              >
                <i className="bi bi-plus-lg"></i> Add
              </button>
              <button
                type="button"
                className="btn btn-success"
                style={{ borderRadius: "6px", padding: "0.55rem 1.1rem" }}
                onClick={() =>
                  dispatch(updateTechnologies([...enteredtechnologies]))
                }
              >
                Save Technologies
              </button>
            </div>
            <div className="text-danger small">{formerror.technologies}</div>
            <ul className="list-group mt-2 shadow-sm" style={{ borderRadius: "6px" }}>
              {enteredtechnologies.map((tech, index) => (
                <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                  {tech.name} (Index: {tech.index})
                  <div>
                    <img
                      src={tech.image}
                      alt={tech.name}
                      style={{
                        maxWidth: "50px",
                        maxHeight: "50px",
                        marginLeft: "10px",
                        borderRadius: "6px",
                      }}
                    />
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm"
                      style={{ borderRadius: "4px" }}
                      onClick={() => handleDeleteTechnology(index)}
                    >
                      <i className="bi bi-trash"></i>
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          {/* Platform */}
          <div className="col-md-6 mb-3">
            <label className="fw-semibold mb-2 d-block">
              Enter Built For (Mobile or tablets or web or both or all)
            </label>
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Enter the platform"
              name="platform"
              onChange={(e) => dispatch(updatePlatform(e.target.value))}
              value={platform}
              style={{
                borderRadius: "6px",
                borderColor: "#d0d5dd",
                padding: "0.65rem 0.85rem",
              }}
            />
            <div className="text-danger small">{formerror.platform}</div>
          </div>
          {/* Industry */}
          <div className="col-md-6 mb-3">
            <label className="fw-semibold mb-2 d-block">Enter Industry</label>
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Enter the industry"
              name="industry"
              onChange={(e) => dispatch(updateIndustry(e.target.value))}
              value={industry}
              style={{
                borderRadius: "6px",
                borderColor: "#d0d5dd",
                padding: "0.65rem 0.85rem",
              }}
            />
            <div className="text-danger small">{formerror.industry}</div>
          </div>
          {/* Country */}
          <div className="col-md-6 mb-3">
            <label className="fw-semibold mb-2 d-block">Enter Country</label>
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Enter the country"
              name="country"
              onChange={(e) => dispatch(updateCountry(e.target.value))}
              value={country}
              style={{
                borderRadius: "6px",
                borderColor: "#d0d5dd",
                padding: "0.65rem 0.85rem",
              }}
            />
            <div className="text-danger small">{formerror.country}</div>
          </div>
        </div>
        <div className="mb-4">
          <label className="fw-semibold mb-2 d-block">Enter firstDescription-About Client</label>
          <ReactQuill
            theme="snow"
            modules={modules}
            formats={formats}
            onChange={(value) => dispatch(updateFirstDesc(value))}
            value={firstDescription}
            placeholder="Enter the Description"
            style={{
              minHeight: "180px",
              borderRadius: "6px",
            }}
          />
          <div className="text-danger small">{formerror.firstDescription}</div>
        </div>
        <div className="mb-4">
          <label className="fw-semibold mb-2 d-block">
            Enter youtube video link-If the post Category is AI/ML
          </label>
          <input
            type="text"
            className="form-control shadow-sm"
            placeholder="Enter the Youtube link 1"
            name="ytvideolink1"
            onChange={(e) => dispatch(updateYtVideoLink1(e.target.value))}
            value={youtube1}
            style={{
              borderRadius: "6px",
              borderColor: "#d0d5dd",
              padding: "0.65rem 0.85rem",
              marginBottom: "8px",
            }}
          />
          <input
            type="text"
            className="form-control shadow-sm"
            placeholder="Enter the Youtube link 2"
            name="ytvideolink2"
            onChange={(e) => dispatch(updateYtVideoLink2(e.target.value))}
            value={youtube2}
            style={{
              borderRadius: "6px",
              borderColor: "#d0d5dd",
              padding: "0.65rem 0.85rem",
              marginBottom: "8px",
            }}
          />
          <input
            type="text"
            className="form-control shadow-sm"
            placeholder="Enter the Youtube link 3"
            name="ytvideolink3"
            onChange={(e) => dispatch(updateYtVideoLink3(e.target.value))}
            value={youtube3}
            style={{
              borderRadius: "6px",
              borderColor: "#d0d5dd",
              padding: "0.65rem 0.85rem",
            }}
          />
        </div>
        {/* Description Images 2x2 Grid */}
        <div className="mb-4">
          <label className="fw-semibold mb-2 d-block">Upload Description Images </label>
          <div className="row">
            <div className="col-md-6">
              {/* Image 1 */}
              <label className="form-label">Image 1</label>
              <input type="file" className="form-control shadow-sm" onChange={handledescImage1}
                style={{
                  borderRadius: "6px",
                  borderColor: "#d0d5dd",
                  padding: "0.65rem 0.85rem",
                }}
              />
              <div className="text-danger small">{descImage1Err ? descImage1Err : ""}</div>
              {descImage1 ? (
                <div className="mt-2">
                  <img src={descImage1} alt="Uploaded" className="img-thumbnail" style={{ maxWidth: "300px", borderRadius: "10px" }} />
                  <button type="button" className="btn btn-outline-danger btn-sm mt-2" style={{ borderRadius: "4px" }} onClick={handleRemoveDescImage1}>Remove</button>
                </div>
              ) : (
                <div className="text-muted">{descImage1State}</div>
              )}
              {/* Image 2 */}
              <label className="form-label mt-3">Image 2</label>
              <input type="file" className="form-control shadow-sm" onChange={handledescImage2}
                style={{
                  borderRadius: "6px",
                  borderColor: "#d0d5dd",
                  padding: "0.65rem 0.85rem",
                }}
              />
              <div className="text-danger small">{descImage2Err ? descImage2Err : ""}</div>
              {descImage2 ? (
                <div className="mt-2">
                  <img src={descImage2} alt="Uploaded" className="img-thumbnail" style={{ maxWidth: "300px", borderRadius: "10px" }} />
                  <button type="button" className="btn btn-outline-danger btn-sm mt-2" style={{ borderRadius: "4px" }} onClick={handleRemoveDescImage2}>Remove</button>
                </div>
              ) : (
                <div className="text-muted">{descImage2State}</div>
              )}
            </div>
            <div className="col-md-6">
              {/* Image 3 */}
              <label className="form-label">Image 3</label>
              <input type="file" className="form-control shadow-sm" onChange={handledescImage3}
                style={{
                  borderRadius: "6px",
                  borderColor: "#d0d5dd",
                  padding: "0.65rem 0.85rem",
                }}
              />
              <div className="text-danger small">{descImage3Err ? descImage3Err : ""}</div>
              {descImage3 ? (
                <div className="mt-2">
                  <img src={descImage3} alt="Uploaded" className="img-thumbnail" style={{ maxWidth: "300px", borderRadius: "10px" }} />
                  <button type="button" className="btn btn-outline-danger btn-sm mt-2" style={{ borderRadius: "4px" }} onClick={handleRemoveDescImage3}>Remove</button>
                </div>
              ) : (
                <div className="text-muted">{descImage3State}</div>
              )}
              {/* Image 4 */}
              <label className="form-label mt-3">Image 4</label>
              <input type="file" className="form-control shadow-sm" onChange={handledescImage4}
                style={{
                  borderRadius: "6px",
                  borderColor: "#d0d5dd",
                  padding: "0.65rem 0.85rem",
                }}
              />
              <div className="text-danger small">{descImage4Err ? descImage4Err : ""}</div>
              {descImage4 ? (
                <div className="mt-2">
                  <img src={descImage4} alt="Uploaded" className="img-thumbnail" style={{ maxWidth: "300px", borderRadius: "10px" }} />
                  <button type="button" className="btn btn-outline-danger btn-sm mt-2" style={{ borderRadius: "4px" }} onClick={handleRemoveDescImage4}>Remove</button>
                </div>
              ) : (
                <div className="text-muted">{descImage4State}</div>
              )}
            </div>
          </div>
        </div>
        <button
          type="button"
          className="btn btn-primary w-100 fw-semibold"
          style={{
            background: "linear-gradient(90deg, #1e3a8a, #2563eb)",
            color: "white",
            padding: "14px",
            borderRadius: "8px",
            fontSize: "17px",
            border: "none",
            boxShadow: "0 4px 14px rgba(37, 99, 235, 0.12)",
            cursor: "pointer",
            transition: "0.25s ease",
          }}
          onClick={handleSubmit}
        >
          Submit
        </button>
        {publishError && (
          <div className="text-danger mt-2">{publishError}</div>
        )}
        {successMsg && (
          <div className="alert alert-success mt-3">
            Post Created Successfully!
          </div>
        )}
      </form>
    </div>
  );
}

export default CreatePortfolioPost;
